export enum VideoVisibility {
  OWNER = 'owner',
  WORKSPACE = 'workspace',
  PUBLIC = 'public',
}

export enum FolderVisibility {
  OWNER = 'owner',
  WORKSPACE = 'workspace',
  PUBLIC = 'public',
}
